<template>
    <div id="newflash" :style="{width:clientW+'px',height:clientH+'px'}" style="margin:0 auto" >
        <div class="newframe">
            <div class="newframe-title">
                <img :src="imgPath+'newflashtitle.png'" alt="">
            </div>
            <div class="newframe-content">
                <div class="newlist" v-for="(item,key) in list" :key="key" @click="tourl(item.url)">
                    <div class="newlist-frame" v-if="item.type==1">
                        <div class="newleft">
                            <p>{{item.title}}</p>
                            <p class="time">{{item.time}}</p>
                        </div>
                        <div class="newright">
                            <img :src="item.img" alt="">
                            
                        </div>
                    </div>
                    <div class="newlist-other" v-if="item.type==2">
                        <p>{{item.title}}</p>
                        <p class="time">{{item.time}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="back" @click="black">
            <img :src="imgPath+'back.png'" alt="">
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            clientW:document.body.clientWidth,
            clientH:document.body.clientHeight,
            imgPath:imgPath,
            list:[
                {
                    type:'1',
                    title:"在上海黄浦江畔讲述“顺德故事”",
                    time:'2021-04-02',
                    img:"https://shundeplus.imgs.shundecity.com/shundeplus/images/article/2021/04/02/e09082021040206501637546.jpg",
                    url:'https://shundeplus.shundecity.com/index.php/m/a/125453.html'
                },
                
                {
                    type:'2',
                    title:"【视频】顺德赴上海寻“合伙人”，企业家们有话说",
                    time:'2021-04-01',
                    img:"",
                    url:'https://shundeplus.shundecity.com/index.php/m/a/125452.html'
                },
                {
                    type:'1',
                    title:"【视频】上海黄浦江畔，顺德这场“路演”为何引发强烈反响？",
                    time:'2021-04-01',
                    img:"https://shundeplus.imgs.shundecity.com/shundeplus/images/article/2021/03/31/272f120210331235130823278.jpg",
                    url:'https://shundeplus.shundecity.com/index.php/m/a/125295.html'
                },
                
            ]
        }
    },
    created(){
        this.getViewScale();
    },
    methods: {
         getViewScale(){
            if(this.clientW >= 750){
                this.clientW = 414;
                this.clientH = 730;
            }
            if(this.clientH/this.clientW > 1.5 && this.clientH/this.clientW < 1.6){
                this.screenParm = "smallScreen";
            }else if(this.clientH/this.clientW <= 1.5){
                this.screenParm = "superSmallScreen";
            }else if(this.clientH/this.clientW >= 1.8){
                this.screenParm = "bigScreen";
            }else{
                this.screenParm = "middleScreen";
            }
        },
        black(){
            this.$router.back(-1);//放回上一页
        },
        tourl(val){
            window.location.href= val;
        }
    },
}
</script>
<style lang="less" scoped>
@base:46.875rem;
#newflash{
    background-image: url(https://t.shundecity.com/shzstjh2021/Home/View/Index/images/otherbg.png);
    background-size: 100% 100%;
    position: relative;
    .newframe{
        width: 90%;
        height: 80%;
        padding: 70/@base 10/@base 10/@base;
        position: absolute;
        top:5%;
        left: 50%;
        transform: translateX(-50%);
        background-color: rgba(255, 255, 255, 0.8);
        border-radius: 10px;
        box-shadow:  0 0 20px 10px rgba(255, 255, 255, 0.3);
        .newframe-title{
            width:334/@base;
            position: absolute;
            top: 0;
            left: 50%;
            transform: translate(-50%,-30%);
        }
        .newframe-content{
            width: 100%;
            height: 100%;
            overflow-y: auto;
            .newlist{
                
                border-bottom: 1px solid #adadad;
                padding-top: 20/@base;
                .newlist-frame{
                    display: flex;
                    align-items: flex-start;
                    justify-content: space-around;
                    .newleft{
                        width: 60%;
                        min-height: 3.456rem;
                        padding-bottom:1.322rem ;
                        position: relative;
                        p{
                            font-size: 0.7253rem;
                            text-align: justify;
                            line-height: 1.5;
                        }
                        .time{
                            position: absolute;
                            left: 0;
                            bottom:20/@base;
                            font-size: 0.4rem;

                        }
                    }
                    .newright{
                        width: 4.608rem;
                        height: 3.456rem;
                        object-fit: cover;
                        
                    }
                }
                .newlist-other{
                    width: 100%;
                     padding-bottom:1.322rem ;
                        position: relative;
                    p{
                        font-size: 0.7253rem;
                        text-align: justify;
                        line-height: 1.5;
                    }
                    .time{
                        position: absolute;
                        left: 0;
                        bottom:20/@base;
                        font-size: 0.4rem;

                    }
                }
                
            }
        }
    }
    .back{
        position: absolute;
        width: 113/@base;
        left: 50%;
        top: 88%;
        transform: translateX(-50%);
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/Newflash.vue